import Vue from 'vue'
import Constants from 'src/utilities/constants'
import dayjs from 'dayjs'
import {ptracGetEntities} from 'src/utilities/ptracApi'
import {encodeDateTimeToURI} from 'src/utilities/utils'
import {OK} from 'http-status-codes'
import {make} from 'vuex-pathify'

let initialState = {
  results: [],
  query: {
    entityTypes: [Constants.ENTITIES.TASK, Constants.ENTITIES.JOB, Constants.ENTITIES.PROJECT],
    queryByCreatedAt: true,
    queryByUpdatedAt: true,
    // dayjs uses slightly different formatting syntax from datepicker
    dateRange: [dayjs(new Date().setHours(0,0,0,0)).format(Constants.DATETIME.URL_FORMAT.DAYJS),
      dayjs(new Date().setHours(23,59,59,999)).format(Constants.DATETIME.URL_FORMAT.DAYJS)],
    userId: null
  }
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)

const mutations = make.mutations(state)

mutations.resetQuery = (state) => {
  state.query = JSON.parse(JSON.stringify(initialState.query))
}

mutations.resetResults = (state) => {
  state.results = []
}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions: {
    async fetchResults({ state, commit }) {
      let endpoint = `findHistory?created=${state.query.queryByCreatedAt}&updated=${state.query.queryByUpdatedAt}&userId=${state.query.userId}&entityTypes=`

      state.query.entityTypes.forEach((type) => {
        endpoint += `${type},`
      })
      endpoint = endpoint.slice(0, -1)
      endpoint += `&startDate=${state.query.dateRange[0]}&endDate=${state.query.dateRange[1]}`

      const response = await ptracGetEntities('history/' + encodeDateTimeToURI(endpoint) + '&limit=1000')

      if (OK === response.status) {
        commit('resetResults')
        commit('results', response.data)
      }

      return response
    }
  }
}
